/* eslint-disable no-useless-escape */
import { AbstractBaseClient } from './abstract-base-client';

class BaseClient extends AbstractBaseClient {
  public setBaseUrl(env: string, tenant: string) {
    this.baseUrl = `https://api-${env}-${tenant}.posito.io/`;
  }
}

class GoApiClient extends AbstractBaseClient {
  public apiPath = 'api/';
  public setBaseUrl(env: string, tenant: string) {
    this.baseUrl = `https://go-api-${env}-${tenant}.posito.io/`;
  }
}

const apiClient = new BaseClient('unset', false); // URL will be set by useFirebase
const goApiClient = new GoApiClient('unset', false); // URL will be set by useFirebase
const mapboxClient = new BaseClient('https://api.mapbox.com/geocoding/v5/', true); // without Authorization header
const googleMapsClient = new BaseClient('https://maps.googleapis.com/maps/api/', true); // without Authorization header

export { apiClient, goApiClient, mapboxClient, googleMapsClient };
